// Bundle.
//
// Three offers beside the option picker: the product on its own, a multi buy
// deal and a bundle, each of the last two a product whose variants are matched
// to this one's by name. Whichever is on decides what the product form posts
// and what the price block says.
//
// It is a snippet, so it does not reach into the section that holds it. The
// section publishes two things on the product root, nextdevPdpVariant for what
// is chosen now and nextdevPdpUpdate to redraw the page, and this hands back
// nextdevPdpOffer, which the section asks on every change: it takes the chosen
// variant, draws every offer against it, and returns the one to post, and
// nextdevPdpOfferName, which row that is, for the gallery. Nothing polls the
// form.

(function () {
  'use strict';

  // the shop's own formatter, assets/nextdev-format-money.js, is what prices
  // go through. What follows it is only for a page that does not have it, a
  // preview above all
  var moneyTpl = window.NextDevMoneyTemplate || '$0';
  var zeroAt = moneyTpl.indexOf('0');
  var moneyPre = zeroAt > -1 ? moneyTpl.slice(0, zeroAt) : '$';
  var moneySuf = zeroAt > -1 ? moneyTpl.slice(zeroAt + 1) : '';

  function money(cents) {
    var rounded = Math.round(cents);
    // round sums show without decimals
    var format = rounded % 100 === 0 ? 'amount_no_decimals' : 'amount';

    var fn = window.formatMoney
      || (window.Shopify && Shopify.formatMoney)
      || null;

    if (fn) {
      try { return fn(rounded, format); } catch (e) { /* falls through */ }
    }

    var whole = String(Math.floor(rounded / 100))
      // the thousands separator the shop's own formatter puts in,
      // or this reads $2499 where the theme reads $2,499
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var frac = rounded % 100;
    var amount = frac === 0
      ? String(whole)
      : whole + '.' + (frac < 10 ? '0' + frac : String(frac));
    return moneyPre + amount + moneySuf;
  }

  function start(wrap) {
    if (wrap.dataset.nextdevBundleInit) return;
    wrap.dataset.nextdevBundleInit = '1';

    var root = wrap.closest('[data-nextdev-pdp]') || document.documentElement;

    // One variant list per row that sells a product of its own, keyed by the
    // row it belongs to. The single offer sells this product, so it has none.
    var lists = {};
    Array.prototype.slice.call(wrap.querySelectorAll('[data-nextdev-pdp-bundle-variants]')).forEach(function (el) {
      var which = el.getAttribute('data-nextdev-pdp-bundle-variants');
      try { lists[which] = JSON.parse(el.textContent) || []; } catch (e) { lists[which] = []; }
    });

    var offerInput = wrap.querySelector('[data-nextdev-pdp-bundle-offer]');
    var chosenLabel = wrap.querySelector('[data-nextdev-pdp-bundle-chosen]');
    var rows = {};
    Array.prototype.slice.call(wrap.querySelectorAll('[data-nextdev-pdp-bundle-tier]')).forEach(function (row) {
      rows[row.getAttribute('data-nextdev-pdp-bundle-tier')] = row;
    });

    var tier = 'single';
    var main = null;

    // Another product's variant for the one chosen in the picker. Shopify
    // writes variant.title as the options joined, so the titles line up where
    // the two products carry the same options; the options themselves are the
    // fallback for a shop that renamed one.
    function twinOf(v, list) {
      if (!v || !list) return null;
      var i;
      for (i = 0; i < list.length; i++) {
        if (list[i].title === v.title) return list[i];
      }
      for (i = 0; i < list.length; i++) {
        if (String(list[i].options) === String(v.options)) return list[i];
      }
      return null;
    }

    function variantFor(which) {
      if (which === 'single') return main;
      return twinOf(main, lists[which]);
    }

    function paintRow(which) {
      var row = rows[which];
      if (!row) return;

      var v = variantFor(which);
      var now = row.querySelector('[data-nextdev-pdp-bundle-now]');
      var was = row.querySelector('[data-nextdev-pdp-bundle-was]');
      var save = row.querySelector('[data-nextdev-pdp-bundle-save]');
      var sep = row.querySelector('[data-nextdev-pdp-bundle-sep]');
      var per = row.querySelector('[data-nextdev-pdp-bundle-per]');
      var note = row.querySelector('[data-nextdev-pdp-bundle-note]');
      var input = row.querySelector('[data-nextdev-pdp-bundle-input]');
      var open = !!(v && v.available);

      row.classList.toggle('nextdev--pdp__bundle-selector-option--unavailable', !open);
      if (input) input.disabled = !open;

      if (now) now.textContent = v ? money(v.price) : '';

      var hasCompare = !!(v && v.compare_at_price && v.compare_at_price > v.price);
      if (was) {
        was.textContent = hasCompare ? money(v.compare_at_price) : '';
        was.hidden = !hasCompare;
      }
      if (save) {
        // the same rule as the price block: a saving that rounds to nothing
        // draws no badge, though the struck price stays
        var savePct = hasCompare
          ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price)
          : 0;
        save.textContent = 'Save ' + savePct + '%';
        save.hidden = savePct < 1;
      }
      if (per) {
        // a placeholder the row fills in, the same as the low stock line's
        // [number]: what one of them comes to at this price
        var count = parseInt(per.getAttribute('data-nextdev-pdp-bundle-per-count'), 10) || 1;
        var text = per.getAttribute('data-nextdev-pdp-bundle-per-text') || '';
        per.textContent = v ? text.replace('[amount]', money(v.price / count)) : '';
      }
      // The separator only stands where there is something on both sides of
      // it, so a row with no saving, or with nothing after it, drops it.
      if (sep) {
        var before = '';
        var after = '';
        var past = false;
        Array.prototype.slice.call(sep.parentNode.children).forEach(function (child) {
          if (child === sep) { past = true; return; }
          if (child.hidden) return;
          if (past) after += child.textContent; else before += child.textContent;
        });
        sep.hidden = !(before.trim() && after.trim());
      }
      // and the line itself goes when everything in it has gone
      if (note) {
        var shown = '';
        Array.prototype.slice.call(note.children).forEach(function (child) {
          if (!child.hidden) shown += child.textContent;
        });
        note.hidden = !shown.trim();
      }
    }

    function paint() {
      Object.keys(rows).forEach(function (which) {
        paintRow(which);
        var on = which === tier;
        rows[which].classList.toggle('nextdev--pdp__bundle-selector-option--selected', on);
        var input = rows[which].querySelector('[data-nextdev-pdp-bundle-input]');
        if (input && input.checked !== on) input.checked = on;
      });

      var row = rows[tier];
      var name = row && row.querySelector('[data-nextdev-pdp-bundle-name]');
      if (chosenLabel && name) chosenLabel.textContent = name.textContent;
      if (offerInput && name) offerInput.value = name.textContent;
    }

    // an offer with nothing to sell falls back to the single one
    function settle() {
      var v = variantFor(tier);
      if (!v || !v.available) tier = 'single';
    }

    // What is included, told to wait for the bundle, rolls open when the
    // bundle is picked and is simply gone when something else is. It is
    // measured rather than given a height in the css, because three cards and
    // a list stand taller on a phone than on a desktop, and a guessed height
    // either cuts the roll short or runs it on past the end. Only a pick the
    // buyer makes rolls it: on load it is just there.
    function reveal(row) {
      if (!row || !row.classList.contains('nextdev--pdp__bundle-selector-option--included-on-choice')) return;
      var panel = row.querySelector('.nextdev--pdp__bundle-selector-included');
      if (!panel || typeof panel.animate !== 'function') return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var style = window.getComputedStyle(panel);
      var height = panel.getBoundingClientRect().height;
      if (!height) return;

      panel.style.overflow = 'hidden';
      var roll = panel.animate([
        { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 },
        { height: height + 'px', paddingTop: style.paddingTop, paddingBottom: style.paddingBottom, opacity: 1 }
      ], { duration: 320, easing: 'cubic-bezier(0.2, 0, 0, 1)' });
      // the clip is only for the roll; a tab in the background never sends
      // the finish, so a timer takes it off as well
      var done = function () { panel.style.overflow = ''; };
      roll.onfinish = done;
      roll.oncancel = done;
      setTimeout(done, 400);
    }

    wrap.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || !input.hasAttribute || !input.hasAttribute('data-nextdev-pdp-bundle-input')) return;
      var row = input.parentNode;
      while (row && !row.hasAttribute('data-nextdev-pdp-bundle-tier')) row = row.parentNode;
      if (!row) return;

      var which = row.getAttribute('data-nextdev-pdp-bundle-tier');
      var v = variantFor(which);
      if (!v || !v.available) { paint(); return; }

      var was = tier;
      tier = which;
      paint();
      if (was !== tier) reveal(rows[tier]);
      if (typeof root.nextdevPdpUpdate === 'function') root.nextdevPdpUpdate();
    });

    // What the section asks on every change: here is the variant the picker
    // chose, hand back the one to post.
    root.nextdevPdpOffer = function (v) {
      main = v;
      settle();
      paint();
      return variantFor(tier);
    };

    // and which row that is, single, deal or bundle, so the gallery can show
    // the pictures of the product being sold
    root.nextdevPdpOfferName = function () {
      return tier;
    };

    // the first draw, against whatever the picker has already chosen
    if (typeof root.nextdevPdpVariant === 'function') {
      root.nextdevPdpOffer(root.nextdevPdpVariant());
    }
  }

  function boot() {
    document.querySelectorAll('[data-nextdev-pdp-bundle]').forEach(start);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // the theme editor draws a section again after a change
  document.addEventListener('shopify:section:load', boot);
})();